(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  if (window.__spQuickbuyTracking) return;
  window.__spQuickbuyTracking = true;

  var TEMPLATE = (document.body.className.match(/\btemplate-([a-z0-9-]+)/) || [, 'unknown'])[1];
  var queue = [];
  var consent = null; // null = unknown, then true/false

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }

  function deliver(name, props) {
    if (window.__spQA) return;
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }

  function send(name, props) {
    props.template = TEMPLATE;
    if (consent === true) { deliver(name, props); return; }
    if (consent === false) return;            // refused: drop, never queue
    if (queue.length < 40) queue.push([name, props]);
  }

  function settle() {
    var a = allowed();
    if (a === null) return;
    consent = a;
    if (a) queue.forEach(function (q) { deliver(q[0], q[1]); });
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  // Product handle from the URL the panel loads: /products/<handle>?... or
  // /collections/x/products/<handle>.
  function handleOf(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).slice(0, 80) : 'unknown';
  }

  function context(el) {
    var cont = el && el.closest && el.closest('.quickbuy-container');
    if (!cont) return null;
    // Dev's main.js stores the fetched URL on the container; live's older
    // build does not, so fall back to the expanded card's own product link
    // (the container sits inside the card on a grid, beside it in a carousel).
    var row = cont.closest('.collection-slider-row');
    var url = cont.dataset.productUrl;
    if (!url) {
      var block = cont.closest('.product-block') || (row && row.querySelector('.product-block.expanded'));
      var link = block && block.querySelector('a.quickbuy-toggle[href], a[href*="/products/"]');
      url = link ? link.getAttribute('href') : '';
    }
    return { product: handleOf(url), surface: row ? 'carousel' : 'grid' };
  }

  document.addEventListener('on:quickbuy:before-open', function (ev) {
    var c = context(ev.target);
    if (c) send('sp_quickbuy_open', c);
  });

  document.addEventListener('on:cart:add', function (ev) {
    var c = context(ev.target);
    if (!c) return;
    c.variant_id = ev.detail && ev.detail.variantId ? String(ev.detail.variantId) : '';
    send('sp_quickbuy_added', c);
  });
})();
